import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../config';

const TemperatureCheckCard = ({ journey, onCheckin, onRescue }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleCheckin = async (rating) => {
    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/journey/midpoint`, { rating });
      if (res.data.needs_rescue && onRescue) {
        // User is struggling - trigger rescue mode
        onRescue();
      } else if (onCheckin) {
        onCheckin(res.data);
      }
    } catch (err) {
      alert('Failed to submit check-in. Please try again.');
    }
    setSubmitting(false);
  };

  const daysCompleted = journey?.daily_logs?.length || 0;
  const targetDays = journey?.target_days || 14;

  return (
    <div className="bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-200 rounded-2xl p-6 shadow-sm">
      <div className="text-center mb-6">
        <span className="text-4xl">🌡️</span>
        <h3 className="text-xl font-bold text-amber-900 mt-2">Halfway there!</h3>
        <p className="text-amber-700 mt-1">
          Day {daysCompleted} of {targetDays} — How does this habit feel right now?
        </p>
      </div>

      <div className="space-y-3">
        <button
          onClick={() => handleCheckin('easy')}
          disabled={submitting}
          className="w-full py-4 px-4 bg-green-100 hover:bg-green-200 text-green-800 font-medium rounded-xl transition flex items-center justify-center gap-3 disabled:opacity-50"
        >
          <span className="text-2xl">🟢</span>
          <div className="text-left">
            <div className="font-semibold">Easy</div>
            <div className="text-sm opacity-75">Automatic</div>
          </div>
        </button>

        <button
          onClick={() => handleCheckin('moderate')}
          disabled={submitting}
          className="w-full py-4 px-4 bg-yellow-100 hover:bg-yellow-200 text-yellow-800 font-medium rounded-xl transition flex items-center justify-center gap-3 disabled:opacity-50"
        >
          <span className="text-2xl">🟡</span>
          <div className="text-left">
            <div className="font-semibold">Moderate</div>
            <div className="text-sm opacity-75">A bit of work</div>
          </div>
        </button>

        <button
          onClick={() => handleCheckin('struggle')}
          disabled={submitting}
          className="w-full py-4 px-4 bg-red-100 hover:bg-red-200 text-red-800 font-medium rounded-xl transition flex items-center justify-center gap-3 disabled:opacity-50"
        >
          <span className="text-2xl">🔴</span>
          <div className="text-left">
            <div className="font-semibold">Struggle</div>
            <div className="text-sm opacity-75">Forcing it</div>
          </div>
        </button>
      </div>

      <p className="text-center text-sm text-amber-600 mt-4">
        Be honest — there's no wrong answer. We're here to help.
      </p>
    </div>
  );
};

export default TemperatureCheckCard;
